import { useEffect, useRef, useState } from 'react';
import API from '../api/axios';
import { io } from 'socket.io-client';
import { useParams, useNavigate } from 'react-router-dom';
import './GroupChatDetail.css';

const GroupChatDetail = () => {
    const { chatId } = useParams();
    const [messages, setMessages] = useState([]);
    const [chatTitle, setChatTitle] = useState('');
    const messagesEndRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadMessages();

        const socket = io('https://apicmobot.cryptovoke.com/panel');

        socket.on('new_group_message', (msg) => {
            if (msg.chat_id === Number(chatId)) {
                setMessages(prev => [...prev, msg]);
            }
        });

        return () => socket.disconnect();
    }, [chatId]);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const loadMessages = async () => {
        try {
            const res = await API.get(`/group-messages?chat_id=${chatId}`);
            setMessages(res.data);
            if (res.data.length > 0) {
                setChatTitle(res.data[0].chat_title);
            }
            // Mesajları okundu işaretle
            await API.post('/group-messages/read', { chat_id: chatId });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="chat-detail-page">
            <div className="chat-header">
                <button className="back-btn" onClick={() => navigate('/group-messages')}>←</button>
                <h1>{chatTitle || 'Group Chat'}</h1>
            </div>
            <div className="messages-container">
                {messages.map(msg => (
                    <div key={msg.id} className="message-bubble">
                        <div className="message-sender">
                            {msg.sender_name || msg.sender_username || 'Unknown'}
                        </div>
                        <div className="message-text">{msg.message_text}</div>
                        <div className="message-time">
                            {new Date(msg.sent_at).toLocaleTimeString()}
                        </div>
                    </div>
                ))}
                <div ref={messagesEndRef} />
            </div>
        </div>
    );
};

export default GroupChatDetail;